import React, { Component } from "react";
import FotoField from "../general/FotoField";

class Form extends Component {
    state = {
        cargo: "",
    };
    componentDidMount() {
        this.setState({
            cargo: this.props.empleado.tipo,
        });
    }
    onInputChange = (e) => {
        const tipo = this.getTipo(e.target.value);

        this.setState({
            cargo: tipo.nombre,
        });
    };
    getTipo = (id) => {
        return this.props.tipos.filter((tipo) => tipo.id === parseInt(id))[0];
    };
    render() {
        const { empleado, errors, tipos, codigo } = this.props;
        const { cargo } = this.state;
        return (
            <div>
                <div className='row'>
                    <div className='col-md-6'>
                        <div className='form-group'>
                            <label className='label form-control-label'>
                                Nombre:
                            </label>
                            <input
                                type='text'
                                className='text-input form-control'
                                id='nombre'
                                name='nombre'
                                defaultValue={empleado.nombre}
                            />
                            {errors.nombre && (
                                <small className='help-blockParams form-Text'>
                                    {errors.nombre[0]}
                                </small>
                            )}
                        </div>
                    </div>
                    <div className='col-md-6'>
                        <div className='form-group'>
                            <label className='label form-control-label'>
                                Apellido:
                            </label>
                            <input
                                type='text'
                                className='text-input form-control'
                                id='apellido'
                                name='apellido'
                                defaultValue={empleado.apellido}
                            />
                            {errors.apellido && (
                                <small className='help-blockParams form-Text'>
                                    {errors.apellido[0]}
                                </small>
                            )}
                        </div>
                    </div>
                </div>
                <div className='row'>
                    <div className='col-md-6'>
                        <div className='form-group'>
                            <label className='label form-control-label'>
                                Cédula:
                            </label>
                            <input
                                type='text'
                                className='text-input form-control'
                                id='cedula'
                                name='cedula'
                                defaultValue={empleado.cedula}
                            />
                            {errors.cedula && (
                                <small className='help-blockParams form-Text'>
                                    {errors.cedula[0]}
                                </small>
                            )}
                        </div>
                    </div>
                    <div className='col-md-6'>
                        <div className='form-group'>
                            <label className='label form-control-label'>
                                Fecha de Nacimiento:
                            </label>
                            <div className='input-group'>
                                <div className='input-group-addon'>
                                    <i className='far fa-calendar' />
                                </div>
                                <input
                                    type='date'
                                    className='text-input form-control'
                                    defaultValue={empleado.fechaNacimiento}
                                    name='fecha_nacimiento'
                                />
                            </div>
                            {errors.fecha_nacimiento && (
                                <small className='help-blockParams form-Text'>
                                    {errors.fecha_nacimiento[0]}
                                </small>
                            )}
                        </div>
                    </div>
                </div>
                <div className='row'>
                    <div className='col-md-12'>
                        <div className='form-group'>
                            <label className='label form-control-label'>
                                Dirección:
                            </label>
                            <input
                                type='text'
                                className='text-input form-control'
                                id='direccion'
                                name='direccion'
                                rows='7'
                                defaultValue={empleado.direccion}
                            />
                            {errors.direccion && (
                                <small className='help-blockParams form-Text'>
                                    {errors.direccion[0]}
                                </small>
                            )}
                        </div>
                    </div>
                </div>
                <div className='row'>
                    <div className='col-md-6'>
                        <div className='form-group'>
                            <label className='label form-control-label'>
                                Estado Civil:
                            </label>
                            <select
                                key={empleado.id}
                                className='text-input form-control'
                                id='estado_civil'
                                name='estado_civil'
                                defaultValue={empleado.estadoCivil}>
                                <option value='soltero'>Soltero</option>
                                <option value='casado'>Casado</option>
                                <option value='union-libre'>Unión Libre</option>
                            </select>
                            {errors.estado_civil && (
                                <small className='help-blockParams form-Text'>
                                    {errors.estado_civil[0]}
                                </small>
                            )}
                        </div>
                    </div>
                    <div className='col-md-6'>
                        <div className='form-group'>
                            <label className='label form-control-label'>
                                Foto:
                            </label>
                            <FotoField
                                foto={empleado.foto}
                                fotoCed={empleado.fotoCed}
                                name='foto'
                            />
                        </div>
                    </div>
                </div>
                <div className='form-separator' />
                <div className='row'>
                    <div className='col-md-6'>
                        <div className='form-group'>
                            <label className='label form-control-label'>
                                Cargo:
                            </label>
                            {tipos.length > 0 && (
                                <select
                                    key={empleado.id}
                                    className='text-input form-control'
                                    id='tipo_id'
                                    onChange={this.onInputChange}
                                    defaultValue={empleado.tipoId}
                                    name='tipo_id'>
                                    <option value=''>- Seleccionar -</option>
                                    {tipos.map((tipo) => (
                                        <option key={tipo.id} value={tipo.id}>
                                            {tipo.nombre}
                                        </option>
                                    ))}
                                </select>
                            )}
                            {errors.tipo_id && (
                                <small className='help-blockParams form-Text'>
                                    {errors.tipo_id[0]}
                                </small>
                            )}
                        </div>
                    </div>
                    <div className='col-md-6'>
                        <div className='form-group'>
                            <label className='label form-control-label'>
                                Código: {codigo && <small>Último Utilizado: {codigo.ultimo}</small>}
                            </label>
                            <input
                                type='text'
                                className='text-input form-control'
                                id='codigo'
                                name='codigo'
                                defaultValue={empleado.nombre ? empleado.codigo : codigo.mayor}
                            />
                            {errors.codigo && (
                                <small className='help-blockParams form-Text'>
                                    {errors.codigo[0]}
                                </small>
                            )}
                        </div>
                    </div>
                </div>
                {cargo && cargo.toLowerCase() === "chofer" && (
                    <div className='row'>
                        <div className='col-md-6'>
                            <div className='form-group'>
                                <label className='label form-control-label'>
                                    Licencia:
                                </label>
                                <select
                                    type='text'
                                    className='text-input form-control'
                                    id='licencia'
                                    name='licencia'
                                    defaultValue={empleado.licencia}>
                                    <option value=''>- Seleccionar -</option>
                                    <option value='categoria-1'>
                                        Categoría 1
                                    </option>
                                    <option value='categoria-2'>
                                        Categoría 2
                                    </option>
                                    <option value='categoria-3'>
                                        Categoría 3
                                    </option>
                                    <option value='categoria-4'>
                                        Categoría 4
                                    </option>
                                    <option value='categoria-5'>
                                        Categoría 5
                                    </option>
                                </select>
                                {errors.licencia && (
                                    <small className='help-blockParams form-Text'>
                                        {errors.licencia[0]}
                                    </small>
                                )}
                            </div>
                        </div>
                        <div className='col-md-6'>
                            <div className='form-group'>
                                <label className='label form-control-label'>
                                    Expiración Licencia:
                                </label>
                                <div className='input-group'>
                                    <div className='input-group-addon'>
                                        <i className='far fa-calendar' />
                                    </div>
                                    <input
                                        type='date'
                                        className='text-input form-control'
                                        defaultValue={empleado.licenciaExpira}
                                        name='licencia_expira'
                                    />
                                </div>
                                {errors.licencia_expira && (
                                    <small className='help-blockParams form-Text'>
                                        {errors.licencia_expira[0]}
                                    </small>
                                )}
                            </div>
                        </div>
                    </div>
                )}
                <div className='row'>
                    <div className='col-md-6'>
                        <div className='form-group'>
                            <label className='label form-control-label'>
                                Fecha Ingreso:
                            </label>
                            <div className='input-group'>
                                <div className='input-group-addon'>
                                    <i className='far fa-calendar' />
                                </div>
                                <input
                                    type='date'
                                    className='text-input form-control'
                                    defaultValue={empleado.fechaIngreso}
                                    name='fecha_ingreso'
                                />
                            </div>
                            {errors.fecha_ingreso && (
                                <small className='help-blockParams form-Text'>
                                    {errors.fecha_ingreso[0]}
                                </small>
                            )}
                        </div>
                    </div>
                    <div className='col-md-6'>
                        <div className='form-group'>
                            <label className='label form-control-label'>
                                Fecha de Salida:
                            </label>
                            <div className='input-group'>
                                <div className='input-group-addon'>
                                    <i className='far fa-calendar' />
                                </div>
                                <input
                                    type='date'
                                    className='text-input form-control'
                                    defaultValue={empleado.fechaSalida}
                                    name='fecha_salida'
                                />
                            </div>
                            {errors.fecha_salida && (
                                <small className='help-blockParams form-Text'>
                                    {errors.fecha_salida[0]}
                                </small>
                            )}
                        </div>
                    </div>
                </div>
                <div className='row'>
                    <div className='col-md-6'>
                        <div className='form-group'>
                            <label className='label form-control-label'>
                                Teléfono:
                            </label>
                            <input
                                type='text'
                                className='text-input form-control'
                                id='telefono'
                                name='telefono'
                                defaultValue={empleado.telefono}
                            />
                            {errors.telefono && (
                                <small className='help-blockParams form-Text'>
                                    {errors.telefono[0]}
                                </small>
                            )}
                        </div>
                    </div>
                    <div className='col-md-6'>
                        <div className='form-group'>
                            <label className='label form-control-label'>
                                Flota:
                            </label>
                            <input
                                type='text'
                                className='text-input form-control'
                                id='flota'
                                name='flota'
                                defaultValue={empleado.flota}
                            />
                            {errors.flota && (
                                <small className='help-blockParams form-Text'>
                                    {errors.flota[0]}
                                </small>
                            )}
                        </div>
                    </div>
                </div>
                <div className='row'>
                    <div className='col-md-6'>
                        <div className='form-group'>
                            <label className='control-label'>Tipo:</label>
                            <select
                                className='form-control'
                                id='informal'
                                name='informal'
                                defaultValue={empleado.informal ? "si" : "no"}>
                                <option value='no'>Formal</option>
                                <option value='si'>Informal</option>
                            </select>
                            {errors.informal && (
                                <small className='help-blockParams form-Text'>
                                    {errors.informal[0]}
                                </small>
                            )}
                        </div>
                    </div>
                    <div className='col-md-6'>
                        <div
                            className='form-group'
                            style={{ marginTop: "40px" }}>
                            <span style={{ marginRight: "15px" }}>Activo:</span>
                            <label className='switch switch-3d switch-success mr-3'>
                                <input type='hidden' name='active' value='no' />
                                <input
                                    key={empleado.id}
                                    type='checkbox'
                                    className='switch-input'
                                    id='active'
                                    name='active'
                                    value='si'
                                    defaultChecked={
                                        empleado.id ? empleado.active : true
                                    }
                                />
                                <span className='switch-label' />
                                <span className='switch-handle' />
                            </label>
                            {errors.active && (
                                <small className='help-blockParams form-Text'>
                                    {errors.active[0]}
                                </small>
                            )}
                        </div>
                    </div>
                </div>
                <div className='form-separator' />
                <div className='row'>
                    <div className='col-md-12'>
                        <div className='form-group'>
                            <label className='label form-control-label'>
                                Notas:
                            </label>
                            <textarea
                                key={empleado.id}
                                className='text-input form-control'
                                id='notas'
                                name='notas'
                                rows='7'
                                defaultValue={empleado.notas}
                            />
                            {errors.notas && (
                                <small className='help-blockParams form-Text'>
                                    {errors.notas[0]}
                                </small>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default Form;
